module.exports = __webpack_public_path__ + "img/symbol_2.a5d9ef09.png";